<div class="toolbar-widget-button" [tooltip]="disabledTooltip" container="sp-toolbar-widget">
    <sup *ngIf="name === widgets.BEFORE_AFTER || name === widgets.CATALOG_PRODUCTS" class="color-active new-label"
        >NEW</sup
    >
    <ng-container [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{}"></ng-container>
    <div [class.disabled]="disabled" (click)="onClick.emit($event)">
        <div class="widget-preview-img" [title]="title">
            <img src="assets/img/websites/elements-icon/lpc-elem-icon-{{ name }}.svg" [alt]="name" />
            <div class="widget-name text-nowrap">
                {{ title }}
            </div>
        </div>
    </div>
</div>
